import React, { useState, useEffect } from "react";
import api from "../axiosConfig";
import { useNavigate } from "react-router-dom";
import { Form, Button, Container, Row, Col } from "react-bootstrap";

import "./pagination.css";

function CreateInvoice() {
  const navigate = useNavigate();
  const [clients, setClients] = useState([]);
  const [products, setProducts] = useState([]);
  const [invoice, setInvoice] = useState({
    client_id: "",
    date: "",
    due_date: "",
    lines: [],
  });

  useEffect(() => {
    api.get("/bxcustomer").then((res) => setClients(res.data));
    api
      .get("/products") // asigură-te că ai această rută
      .then((res) => setProducts(res.data))
      .catch((err) => console.error("Eroare la încărcare produse", err));
  }, []);

  const addLine = () => {
    setInvoice({
      ...invoice,
      lines: [
        ...invoice.lines,
        { product_id: "", quantity: 1, price: 0, tva_rate: 0.19 },
      ],
    });
  };

  const handleLineChange = (index, field, value) => {
    const newLines = [...invoice.lines];
    newLines[index][field] = value;
    setInvoice({ ...invoice, lines: newLines });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/invoices", invoice);
      navigate("/");
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Container className="mt-4">
      <h3 className="mb-4">Creează Factură</h3>
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="clientSelect">
          <Form.Label>Client</Form.Label>
          <Form.Select
            value={invoice.client_id}
            onChange={(e) =>
              setInvoice({ ...invoice, client_id: e.target.value })
            }
            required
          >
            <option value="">Selectează client</option>
            {clients.map((c) => (
              <option key={c.bxid} value={c.bxid}>
                {c.bxdenumire}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <Form.Group className="mb-3" controlId="dateInput">
          <Form.Label>Data</Form.Label>
          <Form.Control
            type="date"
            value={invoice.date}
            onChange={(e) => setInvoice({ ...invoice, date: e.target.value })}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="dueDateInput">
          <Form.Label>Scadență</Form.Label>
          <Form.Control
            type="date"
            value={invoice.due_date}
            onChange={(e) =>
              setInvoice({ ...invoice, due_date: e.target.value })
            }
            required
          />
        </Form.Group>

        <h5 className="mt-4">Produse:</h5>
        {invoice.lines.map((line, index) => (
          <Row className="g-2 align-items-center mb-3" key={index}>
            <Col md={4}>
              <Form.Select
                value={line.product_id}
                onChange={(e) =>
                  handleLineChange(index, "product_id", e.target.value)
                }
              >
                <option value="">-- Selectează produs --</option>
                {products.map((prod) => (
                  <option key={prod.id} value={prod.id}>
                    {prod.name}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={2}>
              <Form.Control
                type="number"
                placeholder="Cantitate"
                value={line.quantity}
                onChange={(e) =>
                  handleLineChange(index, "quantity", e.target.value)
                }
                required
              />
            </Col>
            <Col md={2}>
              <Form.Control
                type="number"
                placeholder="Preț"
                value={line.price}
                onChange={(e) =>
                  handleLineChange(index, "price", e.target.value)
                }
                required
              />
            </Col>
            <Col md={2}>
              <Form.Control
                type="number"
                step="0.01"
                placeholder="TVA"
                value={line.tva_rate}
                onChange={(e) =>
                  handleLineChange(index, "tva_rate", e.target.value)
                }
              />
            </Col>
          </Row>
        ))}

        <div className="d-flex gap-2 mt-3">
          <Button variant="secondary" onClick={addLine}>
            + Adaugă Linie
          </Button>
          <Button variant="primary" type="submit">
            Salvează Factura
          </Button>
        </div>
      </Form>
    </Container>
  );
}

export default CreateInvoice;
